import type { AmbleContent } from "../..";
import { wholesalerContactInfoCoverageAccuracy } from "../../shared/wholesaler-contact-info";

export const ambles: Record<string, AmbleContent> = {
  usa_wholesaler_contact_information: wholesalerContactInfoCoverageAccuracy,
};
